export const environment = {
  production: false,
  apiUrl: 'https://checklist-api.vegease.in/api/v1/',
  // apiUrl: 'http://localhost:3000/api/v1/',

  deviceToken: "deviceToken",
  platform: '3',
  timezone: '480',
};
